import { createTypes, asyncType, createNS } from '@/utils/actionCreator';

export const NS = createNS('WATCHED');

export default createTypes(
  [...asyncType('WATCHED_SERVICES_GET'), 'RESET'],
  `${NS}`
);
